import React, { useState, useEffect } from 'react';
import { translate } from 'react-i18next';
import axios from 'axios';
import { currentHttpOptions } from '../../../common/utilities/utilitiesFunctions';
import GlobalSetupForm from './GlobalSetupForm';
import { Snackbar } from '../../../common/components/UI';
import './GlobalSetup.scss';

const defaultGlobalSetup = {
    isEnabledAutoArchiveStoppedWorkplans: false,
    autoArchiveStoppedWorkplansDelay: 0,
};

const GlobalSetup = ({ t }) => {
    const [globalSetup, setGlobalSetup] = useState(defaultGlobalSetup);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [snackbar, setSnackbar] = useState({
        open: false,
        type: 'success',
        message: '',
    });

    useEffect(() => {
        loadGlobalSetup();
    }, []);

    const loadGlobalSetup = async () => {
        try {
            setIsLoading(true);
            const { data } = await axios.get(
                process.env.REACT_APP_DOTNET_URL + '/api/v1/admin/GlobalSetup',
                currentHttpOptions()
            );

            setGlobalSetup(data);
            setError(null);
        } catch (err) {
            console.error('Error loading global setup:', err);
            setError(err);
            setSnackbar({
                open: true,
                type: 'error',
                message: t('globalSetup.errors.loadFailed'),
            });
        } finally {
            setIsLoading(false);
        }
    };

    const saveGlobalSetup = async (data) => {
        try {
            setIsLoading(true);
            const response = await axios.put(
                process.env.REACT_APP_DOTNET_URL + '/api/v1/admin/GlobalSetup',
                data,
                currentHttpOptions()
            );

            setGlobalSetup(response.data);

            setSnackbar({
                open: true,
                type: 'success',
                message: t('globalSetup.success.saveSuccessful'),
            });
        } catch (err) {
            console.error('Error saving global setup:', err);
            setSnackbar({
                open: true,
                type: 'error',
                message: t('globalSetup.errors.saveFailed'),
            });
        } finally {
            setIsLoading(false);
        }
    };

    const closeSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        <div className="workplan-manager--global-setup">
            {error && (
                <div className="error-message">
                    {t('globalSetup.errors.loadFailed')}
                </div>
            )}
            <GlobalSetupForm
                isGlobalSetupLoading={isLoading}
                globalSetup={globalSetup}
                onSave={saveGlobalSetup}
                t={t}
            />
            {snackbar.open && (
                <Snackbar
                    type={snackbar.type}
                    message={snackbar.message}
                    open={snackbar.open}
                    closeSnackbar={closeSnackbar}
                />
            )}
        </div>
    );
};

export default translate('workplanManager')(GlobalSetup);

